angular.module('impactx.rfxsupplier').component('ixRfxSupplierInfoHeader', {
        bindings: {
            info: '<',
            readOnly: '<',
            isClosed: '<',
            trns: '<',
            conversationFunction: "&"
        },
        controller: 'RFXSupplierInfoHeaderCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-info-header.html'
    }
);